import React from 'react';
import { RouteObject } from 'react-router-dom';
import { Terminals } from './terminals';

export const terminalsRoutes: RouteObject[] = [
  {
    path: '',
    element: <Terminals />,
  },
];
